import { staticText } from '../../utils/translations/staticText';

/**
 * Quote-basis copy, shared by every module that prices travel insurance
 * (CMS-1896 Table Builder, CMS-1956 Quick Answer).
 *
 * It lives with the component rather than in either block: the sentence states
 * the trip behind the prices, and two modules stating it differently would be a
 * defect, not a variation. `{article}` is a placeholder rather than a computed
 * prefix so a translation can drop it — ZH does.
 */
export const QuoteBasisDisclaimerTranslations = staticText({
  disclaimer_single_trip: {
    _: 'Prices shown are calculated for {article} {duration}-day single trip to {destination} for {travellers}, for reference only. The final premium is confirmed at the point of application.',
    zh: '以上價格以{destination}{duration}天單次旅程、{travellers}計算，僅供參考。實際保費以投保時之報價為準。',
  },
  disclaimer_annual_trip: {
    _: 'Prices shown are calculated for an annual multi-trip plan ({region}) for {travellers}, for reference only. The final premium is confirmed at the point of application.',
    zh: '以上價格以{region}全年多次旅程、{travellers}計算，僅供參考。實際保費以投保時之報價為準。',
  },
  disclaimer_travellers_single_adult: {
    _: '1 adult',
    zh: '1位成人',
  },
  disclaimer_travellers_family: {
    _: '2 adults and 1 child',
    zh: '2位成人及1位小童',
  },
});
